// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"2ffd9903253799caf115","703":"8f0343bd6ed35768aab6","886":"289c966c600750c26b81","954":"26c5b0e43d4f6f4a14f1"}[chunkId] + ".js";
};